import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, List, Typography, useTheme } from "@mui/material";
import MobileHeader from "../../../layout/DriverLayout/Header";
import bigCar2 from "../../../../media/images/icons/bigcar2.svg";
import document from "../../../../media/images/icons/document.svg";
import contact from "../../../../media/images/icons/contact.svg";
import EditIcon from "../../../../media/images/icons/edit-icon";
import profileOutline from "../../../../media/images/icons/profile-outlin.svg";
import carApproved from "../../../../media/images/icons/car-approved.svg";
import shieldSec from "../../../../media/images/icons/shield-security.svg";
import settingsIcon from "../../../../media/images/icons/setting-2.svg";
import logoIcon from "../../../../media/images/icons/logo-icon.svg";
import profiledark from "../../../../media/images/icons/profiledark.svg";
import profileImage from "../../../../media/images/profileImage.png";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import { useAppSelector } from "../../../../hooks/useRedux";
import CustomListItem from "../../../layout/AuthLayout/Sidbar/components/ListItem";
import CarTagView from "../../../components/CarTag";

export default function ProfilePage() {
  const divRef = useRef<HTMLDivElement>(null);
  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  const [hasScroll, setHasScroll] = useState(false);

  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            حساب کاربری من
          </Typography>
        }
        hasScroll={hasScroll}
      />
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "16px",
        }}
      >
        {/**section1 */}
        <Box
          sx={{
            position: "relative",
            marginTop: "32px",
            width: "100%",
            backgroundColor: "background.default",
            padding: "16px",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: -32,
              right: 32,
              // border: "1px solid gray",
              height: "64px",
              width: "64px",
            }}
          >
            <img
              style={{
                borderRadius: "50%",
              }}
              src={profileImage}
              alt=""
            />
          </Box>
          <Box
            sx={{
              zIndex: 32,
              position: "absolute",
              right: 32,
              width: 28,
              height: 28,
              // border: "1px solid gray",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor: "background.default",
            }}
          >
            <EditIcon size={20} color={theme.palette.primary.main} />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Box
              sx={{
                padding: "4px 6px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                width: "fit-content",
                backgroundColor: "error.light",
              }}
            >
              <Typography sx={{ color: "error.main" }}>
                حذف عکس پروفایل
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "secondary.main",
              }}
            >
              رضا یعقوبی‌فریان پور
            </Typography>
            <Typography sx={{}}>09155555555</Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: "600" }}>‌کد‌ملی:</Typography>
              <Typography sx={{ fontWeight: "600" }}>0123456789</Typography>
            </Box>
            <CarTagView />
          </Box>
          <Box
            sx={{
              marginTop: "12px",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: "secondary.light",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography sx={{ fontWeight: "600" }}>گروه بارگیری</Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              مسقف یا چادری خاور
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: "secondary.light",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography sx={{ fontWeight: "600" }}>گروه بارگیری</Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              مسقف یا چادری خاور
            </Typography>
          </Box>
        </Box>

        {/**section2 */}

        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "background.default",
            padding: "16px",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              marginTop: "8px",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography sx={{ fontWeight: "600" }}>
                شماره هوشمند ناوگان:
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              88888888
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={document} alt="" />
              <Typography sx={{ fontWeight: "600" }}>
                پایان معاینه فنی:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              1402/12/05
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={contact} alt="" />
              <Typography sx={{ fontWeight: "600" }}>
                اعتبار کارت هوشمند راننده:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              1402/12/05
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={profiledark} alt="" />
              <Typography sx={{ fontWeight: "600" }}>
                پایان کارت سلامت:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              1402/12/05
            </Typography>
          </Box>
        </Box>
        {/**section 3*/}

        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "background.default",
            borderRadius: "16px",
          }}
        >
          <nav
            style={{
              padding: "0px 8px",
            }}
            aria-label="main mailbox folders"
          >
            <List
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <CustomListItem
                path="/edit-profile"
                title="ویرایش اطلاعات و ارسال مدارک"
                icon={profileOutline}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="#"
                title="تغییر ناوگان"
                icon={carApproved}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="#"
                title="تغییر رمز عبور"
                icon={shieldSec}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="#"
                title="تنظیمات اطلاع‌رسانی و دسترسی‌ها"
                icon={settingsIcon}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="/aboutus"
                title="درباره کارن ترابرنت"
                icon={logoIcon}
              />
            </List>
          </nav>
        </Box>
      </Box>
      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}

interface Student {
  name: string;
}

function calmark(params: Student) {}
